// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-campo-form .campo-form-nome.has-error > .editor-wrapper .mce-content-body {\n  border-bottom-color: #a94442 !important;\n}", ""]);
// Exports
module.exports = exports;
